import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import { Link } from 'react-router-dom';
var Desc;
var Setpad = { paddingLeft: '2%' }
var Setheight = { height:'37px'}
let titlelength_1 = false, titlelength_2=false;
export class LeadingLawPublications extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(e) {
        window.scrollTo(0, 0);
       
    }

    componentDidMount() {
        //this.setState({journalList: this.props.journalList});
    }

    stingBreakLine(str, length, ending) {
        str = str.props.dangerouslySetInnerHTML.__html;
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    renderJournals = () => {
        return this.props.journalList != null && this.props.journalList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            Desc = <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
            return (
                <div>
                    <div>
                        <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                            {
                                item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                    (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                        null)
                            }
                            <h3 className="HomepageHeading" style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                                <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h3></Link>
                        <Link onClick={this.handleSelect} to={"/Journals/" + titlePlus + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" /></Link>
                        <div className="SetDesheight">
                            <br></br>
                            <Link onClick={this.handleSelect} to={"/Journals/" + titlePlus + "/" + item.id}><h4 className="BookHeading "><div dangerouslySetInnerHTML={{ __html: item.title }}></div></h4></Link>
                            <p className="BookBody ">{item.description != null ? <div dangerouslySetInnerHTML={{ __html: this.stingBreakLine(Desc, item.ContainLenght, '.....') }}></div> : ""}</p>
                        </div>
                        <div>{key < 1 ? <hr style={{ marginLeft: '-15px' }}></hr> : null} </div>
                    </div><br></br>
                </div>)
        });
    }
    renderEncyclopedias = () => {
        return this.props.encyclopediaList != null && this.props.encyclopediaList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            Desc = <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
            return (
                <div>
                    <div>
                        <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                            {
                                item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                    (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                        null)
                            }
                            <h3 className="Heading" style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                                <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h3></Link>
                        <Link onClick={this.handleSelect} to={"/encyclopedias/" + titlePlus + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" /></Link>
                        <div className="SetDesheight">
                            <br></br>
                            <Link onClick={this.handleSelect} to={"/encyclopedias/" + titlePlus + "/" + item.id}><h4 className="BookHeading "><div dangerouslySetInnerHTML={{ __html: item.title }}></div></h4></Link>
                            <p className="BookBody ">{item.description != null ? <div dangerouslySetInnerHTML={{ __html: this.stingBreakLine(Desc, item.ContainLenght, '.....') }}></div> : ""}</p>
                        </div>
                        <div>{key < 1 ? <hr style={{ marginLeft: '-15px' }}></hr> : null} </div>
                    </div><br></br>
                </div>)
        });
    }
    renderManuals = () => {
       return this.props.manualList != null && this.props.manualList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            Desc = <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
            return (
                <div>
                    <div>
                        <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                            {
                                item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                    (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                        null)
                            }
                            <h3 className="HomepageHeading" style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                                <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h3></Link>
                        <Link onClick={this.handleSelect} to={"/Manuals/" + titlePlus + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" /></Link>
                        <div className="SetDesheight">
                            <br></br>
                            <Link onClick={this.handleSelect} to={"/Manuals/" + titlePlus + "/" + item.id}><h4 className="BookHeading "><div dangerouslySetInnerHTML={{ __html: item.title }}></div></h4></Link>
                            <p className="BookBody ">{item.description != null ? <div dangerouslySetInnerHTML={{ __html: this.stingBreakLine(Desc, item.ContainLenght, '.....') }}></div> : ""}</p>
                        </div>
                        <div>{key < 1 ? <hr style={{ marginLeft: '-15px' }}></hr> : null} </div>
                    </div><br></br>
                </div>)
        });
    }

    render() {
        //console.log(this.props.journalList);        
      

        return (
            <div>
                <div className="row">
                    <div className="col Responsivecol Setmarginforhome" style={{ maxWidth: '30%' }}>
                        {
                            this.renderJournals()
                        }
                        <div className="MoreEncy">
                            <Link onClick={this.handleSelect} to="/AllJournals" className="btn btn-info next" role="button" style={{ padding: '11px 11px 11px 11px' }}>More Journals</Link><img src="/../../images/Arrow-Right.png" alt="" />
                        </div>
                    </div>
                    <div className="col vl" style={{ maxWidth: '1%', padding: '0px', marginLeft: '1%' }}></div>

                    <div className="col Responsivecol" style={{ marginLeft: '1%', maxWidth: '30%' }}>
                        {
                            this.renderEncyclopedias()
                        }
                        <div className="MoreEncy">
                            <Link onClick={this.handleSelect} to="/AllEncyclopedias" className="btn btn-info next" role="button" style={{ padding: '11px 11px 11px 11px' }}>More Encyclopaedias</Link><img src="/../../images/Arrow-Right.png" alt="" />
                        </div>
                    </div>
                    <div className="col vl" style={{ maxWidth: '1%', padding: '0px', marginLeft: '2%' }}></div>

                    <div className="col Responsivecol" style={{ marginLeft: '1%', maxWidth: '30%' }}>
                        {
                            this.renderManuals()
                        }
                        <div className="MoreEncy">
                            <Link onClick={this.handleSelect} to="/AllManuals" className="btn btn-info next" role="button" style={{ padding: '11px 11px 11px 11px' }}>More Manuals</Link><img src="/../../images/Arrow-Right.png" alt="" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="White">
                    </div>
                </div >
            </div >
        )
    }
}

export default LeadingLawPublications;


//<h3 className="LawHeader">Introducing some of our leading law publications</h3>


// WEBPACK FOOTER //
// ./src/components/Home/LeadingLawPublications.jsx